/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */


import { Box, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import { ToastContainer, Zoom, toast } from "react-toastify";
import { handleEditClose } from "../../../redux/Reducer/ModalSlice";

const EditMenu = ({ refetch }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const menuData = useSelector((state) => state.Modal.val);

  // console.log("menu", menuData);

  // console.log(menuData);

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm();

  //192.168.0.89/kyamch_ctms_backend/api/editemoduleSetup/8

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("module_id", data.module_id);
    formData.append("module_name", data.module_name);
    formData.append("active_fg", data.active_fg);
    fetch(
      `${process.env.REACT_APP_API_URL}/api/updatemoduleSetup/${menuData.module_id}`,
      {
        method: "POST",
        body: formData,
        // headers: {
        //   accept: "application/json",
        //   "content-type": "application/json",
        // },

        // body: JSON.stringify(data),
      }
    )
      .then((res) => {
        // console.log("res", res);
        return res.json();
      })
      .then((data) => {
        // console.log("data", data);
        if (data.success === true) {
          refetch();
          dispatch(handleEditClose());
        } else if (data.duplicate === true) {
          toast.error("Module is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <Box mb="20px">
          <TextField
            defaultValue={menuData.module_name}
            size="small"
            fullWidth
            label="Module Name*"
            variant="outlined"
            {...register("module_name", {
              required: true,
              // pattern: /^[a-zA-Z]+$/,
            })}
          />
          {errors?.module_name?.type === "required" && (
            <ErrorMessage>Module Name is required*</ErrorMessage>
          )}
          {/* {errors?.module_name?.type === "pattern" && (
            <ErrorMessage>
              Should not allow inserting any symbol and number
            </ErrorMessage>
          )} */}
        </Box>

        <Box>
          <TextField
            select
            defaultValue={menuData.active_fg}
            size="small"
            fullWidth
            label="Active Status"
            variant="outlined"
            {...register("active_fg", { required: true })}
          >
            <MenuItem value="Y">Active</MenuItem>
            <MenuItem value="N">Inactive</MenuItem>
          </TextField>
          {errors?.active_fg?.type === "required" && (
            <ErrorMessage>Active status is required*</ErrorMessage>
          )}
        </Box>
      </Box>

      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {/* {isLoading ? (
      <ThemButton
        style={
          {
  
          }
        }
        type="submit"
      >
        <SyncLoader color="#FFFFFF" size={8} />
      </ThemButton>
    ) : (
      <ThemButton
        style={
          {
          }
        }
        type="submit"
      >
        Update User Level
      </ThemButton>
    )}

    
    <ToastContainer
      autoClose={2000}
      limit={1}
      transition={Zoom}
      toastStyle={{ border: "2px solid crimson" }}
    /> */}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
        <ThemButton style={{}} type="submit">
          Update
        </ThemButton>
      </Box>
    </form>
  );
};

export default EditMenu;
